module.exports = function() {
  return new Worker(__webpack_public_path__ + "web-worker.cf3d1872bc5e2230c583.js");
};